/**
 * Reduces duplicate spacing into a single space, and removes preceeding and succeeding spaces.
 * Useful for sanitizing user input when duplication is really harmful.
 */
export const cleanStringSpaces = (str: string | null) => (str ? str.replace(/\s+/g, ' ').trim() : null);
